import React from "react";

import { useTranslation } from "utils";

import { HomeSegment } from "pages/app/home/hero/homeSegment";

type HomeHeadlineProps = {
  segment: HomeSegment;
  farmName: string;
  reportingYear: number;
};

export const HomeHeadline = ({ segment, farmName, reportingYear }: HomeHeadlineProps) => {
  const { t } = useTranslation("home");

  const headline = () => {
    switch (segment) {
      case "removals":
      case "removals-footprinting":
      case "fields-footprinting":
        return t("hero.headline.removals", { farmName });
      case "no-program":
        return t("hero.headline.noProgram");
      case "footprinting-only":
        return t("hero.headline.footprintingOnly");
      case "digital-agronomist":
        return t("hero.headline.digitalAgronomist", { reportingYear });
      default: {
        const unknownSegment: never = segment;
        return unknownSegment;
      }
    }
  };

  return (
    <span className="home-hero-headline" data-testid="home-hero-headline">
      {headline()}
    </span>
  );
};
